export default __webpack_public_path__ + "static/A1_M2-10d084980c2960fda5bfea9ec3f70e49.png";